import getStore from '../store';

export default function hasSelectedProject(): boolean {
    const { selectedProjectId } = getStore();
    return !!selectedProjectId;
}
